import React, { useState } from "react";
import { useForm } from "react-hook-form";
import BaseDatePicker from "../../components/Base/BaseDatePicker";
import PageName from "../../components/PageName";
import Card from "../../components/Base/Card";
import SuccessModal from "../../components/SuccessModal";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import {requestThirdPartyStatement} from "../../redux/statement/statementSlice";
import LoadingSpinner from "../../components/LoadingSpinner";
import * as Yup from "yup";
import {yupResolver} from "@hookform/resolvers/yup";
import ErrorViewer from "../../components/ErrorViewer";
import TimeOutActivityLayout from "../auth/inactivity-timeout-v2";

const lastYearToday = new Date();
lastYearToday.setFullYear(lastYearToday.getFullYear() - 1);

const RequestStatement = () => {
    const dispatch = useAppDispatch();
    const [showSuccessModal, setSuccessModal] = useState(false);
    const { isLoading } = useAppSelector((state) => state?.statement);
    const { user }  = useAppSelector(state=>state.auth)

    const validationSchema = Yup.object().shape({
        email: Yup.string().required("Email is required").email("Not a valid email"),
        startDate: Yup.string().required("Start Date is required"),
        endDate: Yup.string().required("End Date is required"),
    });

    const initialValues = {
        email: "",
        startDate: "",
        endDate: "",
    };

    const { handleSubmit, register, setValue, reset, trigger, formState: { errors }, } = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: { ...initialValues },
    });

    const onSubmit = async (inputted: any) => {
        dispatch(requestThirdPartyStatement({
            ThirdPartyEmail: inputted.email,
            Pin: user.pin,
            startDate: new Date(inputted.startDate).toISOString(),
            endDate: new Date(inputted.endDate).toISOString(),
        })).then(res=>{
            if (res.type==="request/thirdPartyStatement/fulfilled" && res.payload.statusCode === "00") {
                reset();
            }
        });
    };

    const toggleShowSuccessModal = () => setSuccessModal(!showSuccessModal);

    return (
        <TimeOutActivityLayout>
        <div className="statement-page">
            <SuccessModal
                showModal={showSuccessModal}
                onClose={toggleShowSuccessModal}
                note={"Your RSA statement has been sent to the provided email."}
            />
            <PageName pageName={"Request Statement (Third Party)"} />
            <div className="statement">
                <Card className="statement-page-card">
                    <div className="h1 text-grayscaleBody">Request Statement (Third Party)</div>
                    <Card>
                        <div className="statement-card">
                            <div>Request Information</div>
                            <div className="w-full">
                                <form action="" className="form">
                                    <div className="form__row">
                                        {/* <div className="form__group">
                      <label htmlFor="statement-type" className="form__label">
                        Statement Type
                      </label>
                      <select className="form__select" {...register("type")}>
                        <option value="individual">Individual</option>
                        <option value="corporate">Corporate</option>
                      </select>
                    </div> */}
                                        <div className="form__group">
                                            <label htmlFor="recipient-email" className="form__label">
                                                Recipient email address
                                            </label>
                                            <input
                                                type="email"
                                                className="form__input"
                                                placeholder="Enter recipient email address"
                                                {...register("email")}
                                            />
                                            {errors.email && (
                                                <ErrorViewer message={errors.email.message as string}/>
                                            )}
                                        </div>
                                    </div>
                                    <div className="form__row">
                                        <div className="form__group">
                                            <label htmlFor="" className="form__label">
                                                Start Date
                                            </label>
                                            <BaseDatePicker
                                                onChange={(date: Date) => {
                                                    // @ts-ignore
                                                    setValue("startDate", date);
                                                    trigger("startDate");
                                                }}
                                            />
                                            {errors.startDate && (
                                                <ErrorViewer message={errors.startDate.message as string}/>
                                            )}
                                        </div>
                                        <div className="form__group">
                                            <label htmlFor="" className="form__label">
                                                End Date
                                            </label>
                                            <BaseDatePicker
                                                onChange={(date: Date) => {
                                                    // @ts-ignore
                                                    setValue("endDate", date);
                                                    trigger("endDate")
                                                }}
                                            />
                                            {errors.endDate && (
                                                <ErrorViewer message={errors.endDate.message as string}/>
                                            )}
                                        </div>
                                        <div className="form__group"></div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </Card>
                    <div className="flex justify-end mt-4">
                        {/*
            <button className="btn btn-outline btn-b" onClick={reset}>
              Reset
            </button>
            */}
                        <button
                            type="submit"
                            style={{ backgroundColor: "#305F32" }}
                            className="btn btn-primary btn-b ml-4"
                            onClick={handleSubmit(onSubmit)}
                            disabled={isLoading}
                        >
                            {isLoading ? <LoadingSpinner /> :
                                "Generate Statement"}
                        </button>
                    </div>
                </Card>
            </div>
        </div>
        </TimeOutActivityLayout>
    );
};
export default RequestStatement;
